module.exports = __webpack_public_path__ + "img/trafo.3b6bc8e6.svg";